import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

/**
 * Props for OnboardClientAccessSubmitted event.
 *
 * @property access_level - the selected access level (e.g., 'TRADE' | 'NONE')
 */
export interface OnboardClientAccessSubmittedProps extends EventProps {
    access_level: string
}

/**
 * @event OnboardClientAccessSubmitted
 * @description Emitted when the participant access profile is submitted during client onboarding.
 */
export const OnboardClientAccessSubmittedAnalytics = createAnalyticsStatic<OnboardClientAccessSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARD_CLIENT_ACCESS_SUBMITTED,
)

export default OnboardClientAccessSubmittedAnalytics
